export const REPEAT_BOOKING = {
  REPEAT: {
    EN: 'Repeat',
    TH: 'เกิดซ้ำ',
  },
  REPEAT_TITLE: {
    EN: 'Repeat : ',
    TH: 'เกิดซ้ำ : ',
  },
  OFF: {
    EN: 'Off',
    TH: 'ปิด',
  },
  CUSTOM_RECURRENCE: {
    EN: 'Custom Recurrence',
    TH: 'กำหนดรูปแบบการเกิดซ้ำ',
  },
  EVERY: {
    EN: 'Repeat every',
    TH: 'เกิดซ้ำทุก',
  },
  ON: {
    EN: 'Repeat on',
    TH: 'เกิดซ้ำใน',
  },
  ENDS: {
    EN: 'Ends',
    TH: 'สิ้นสุด',
  },
  ON_DATE: {
    EN: 'On',
    TH: 'ในวันที่',
  },
  AFTER: {
    EN: 'After',
    TH: 'หลังจาก',
  },
  OCCURRENCES: {
    EN: 'occurrences',
    TH: 'ครั้ง',
  },
  DONE: {
    TH: 'เสร็จสิ้น',
    EN: 'Done',
  },
  CHANGE: {
    TH: 'เปลี่ยน',
    EN: 'Change',
  },
  OCCURRENCES_ERROR: {
    TH: 'กรุณาใส่หมายเลขที่ถูกต้อง',
    EN: 'Please enter valid number',
  },
  NOTE: {
    TH: 'หมายเหตุ - เมื่อเปิดการใช้งานฟีเจอร์นี้, คุณจะได้รับอีเมลแจ้งเตือน ตามจำนวนครั้งของการประชุม',
    EN: 'Note - Upon enabling the feature, You will receive an email notification for every repeat meeting.',
  },
}

export const CALENDAR_UNIT_EN = [
  {
    key: 'day',
    value: 'day',
  },
  { 
    key: 'week',
    value: 'week',
  },
  { 
    key: 'month',
    value: 'month',
  },
  { 
    key: 'year',
    value: 'year',
  },
]

export const CALENDAR_UNIT_TH = [
  {
    key: 'day',
    value: 'วัน',
  },
  { 
    key: 'week',
    value: 'สัปดาห์',
  },
  { 
    key: 'month',
    value: 'เดือน',
  },
  { 
    key: 'year',
    value: 'ปี',
  },
]

export const WEEK_EN = [
  {
    key: 'sunday',
    value: 'S',
  },
  { 
    key: 'monday',
    value: 'M',
  },
  { 
    key: 'tuesday',
    value: 'T',
  },
  { 
    key: 'wednesday',
    value: 'W',
  },
  { 
    key: 'thursday',
    value: 'T',
  },
  { 
    key: 'friday',
    value: 'F',
  },
  { 
    key: 'saturday',
    value: 'S',
  },
]

export const WEEK_TH = [
  {
    key: 'sunday',
    value: 'อา',
  },
  { 
    key: 'monday',
    value: 'จ',
  },
  { 
    key: 'tuesday',
    value: 'อ',
  },
  { 
    key: 'wednesday',
    value: 'พ',
  },
  { 
    key: 'thursday',
    value: 'พฤ',
  },
  { 
    key: 'friday',
    value: 'ศ',
  },
  { 
    key: 'saturday',
    value: 'ส',
  },
]

export const REPEAT_TOGGLE = [
  {
    key: 'on',
    EN: 'On',
    TH: 'เปิด',
  },
  {
    key: 'off',
    EN: 'Off',
    TH: 'ปิด',
  }
]

export const WEEK_ORDER = [
  {
    key: 'first',
    EN: 'first',
    TH: 'แรก',
  },
  {
    key: 'second',
    EN: 'second',
    TH: 'สอง',
  },
  {
    key: 'third',
    EN: 'third',
    TH: 'สาม',
  },
  {
    key: 'fourth',
    EN: 'fourth',
    TH: 'สอง',
  },
  {
    key: 'last',
    EN: 'last',
    TH: 'สุดท้าย',
  }
]

export const REPEAT_MONTHLY = {
  ON_DATE: {
    EN: (date) => `Monthly on day ${date}`,
    TH: (date) => `รายเดือนในวันที่ ${date}`,
  },
  ON_DAY_NAME: {
    EN: (dayName) => `Monthly on the ${dayName}`,
    TH: (dayName) => `รายเดือนในวัน${dayName}`,
  },
  AT: {
    EN: '', // is empty
    TH: 'ที่',
  }
}

export const REPEAT_RESULT = {
  DAILY : {
    UNTIL: {
      EN: (occurrence, date) => `${occurrence === 1 ? 'Daily, until' : `Every ${occurrence} days, until`} ${date}`,
      TH: (occurrence, date) => `${occurrence === 1 ? 'รายวัน, จนถึง' : `ทุก ${occurrence} วัน, จนถึงวันที่`} ${date}`,
    },
    AFTER: {
      EN: (occurrence, times) => `${occurrence === 1 ? 'Daily,' : `Every ${occurrence} days,`} ${times} times`,
      TH: (occurrence, times) => `${occurrence === 1 ? 'รายวัน,' : `ทุก ${occurrence} วัน,`} ${times} ครั้ง`,
    }
  },
  WEEKLY : {
    UNTIL: {
      EN: (occurrence, dayName, date) => `${occurrence === 1 ? 'Weekly on' : `Every ${occurrence} weeks on`} ${dayName}, until ${date}`,
      TH: (occurrence, dayName, date) => `${occurrence === 1 ? 'รายสัปดาห์ในวัน' : `ทุก ${occurrence} ในวัน`}${dayName}, จนถึงวันที่ ${date}`,
    },
    AFTER: {
      EN: (occurrence, dayName, times) => `${occurrence === 1 ? 'Weekly on' : `Every ${occurrence} weeks on`} ${dayName}, ${times} times`,
      TH: (occurrence, dayName, times) => `${occurrence === 1 ? 'รายสัปดาห์ใน' : `ทุก ${occurrence} สัปดาห์ ใน`} ,${dayName} ${times} ครั้ง`,
    }
  },
  WEEKLY_All_DAYS : {
    UNTIL: {
      EN: (occurrence, date) => `${occurrence === 1 ? 'Weekly on all days, until' : `Every ${occurrence} weeks on all days`} ${date}`,
      TH: (occurrence, date) => `${occurrence === 1 ? 'รายสัปดาห์ในทุกวัน,' : `ทุก ${occurrence} สัปดาห์ ในทุกวัน`} จนถึงวันที่ ${date}`,
    },
    AFTER: {
      EN: (occurrence, times) => `${occurrence === 1 ? 'Weekly on all day': `Every ${occurrence} weeks on all days`} ${times} times`,
      TH: (occurrence, times) => `${occurrence === 1 ? 'รายสัปดาห์ในทุกวัน,' : `ทุก ${occurrence} สัปดาห์ ในทุกวัน,`} ${times} ครั้ง`,
    }
  },
  MONTHLY: {
    UNTIL: {
      EN: (occurrence, startDate, endDate) => `${occurrence === 1 ? '' : `Every ${occurrence} `}${startDate}, until ${endDate}`,
      TH: (occurrence, startDate, endDate) => `${occurrence === 1 ? '' : `ทุก ${occurrence} `}${startDate}, จนถึง ${endDate}`,
    },
    AFTER: {
      EN: (occurrence, date, times) => `${occurrence === 1 ? '' : `Every ${occurrence} months on ` }${date}, ${times} times`,
      TH: (occurrence, date, times) => `${occurrence === 1 ? '' : `ทุก ${occurrence} เดือน ในวันที่ `}${date}, ${times} ครั้ง`,
    },
  },
  YEARLY: {
    UNTIL: {
      EN: (occurrence, startDate, endDate) => `${occurrence === 1 ? 'Annually on' : `Every ${occurrence} years on`} ${startDate}, until ${endDate}`,
      TH: (occurrence, startDate, endDate) => `${occurrence === 1 ? 'รายปีในเดือน' : `ทุก ${occurrence} ปี ในเดือน`} ${startDate}, จนถึงวันที่ ${endDate}`,
    },
    AFTER: {
      EN: (occurrence, date, times) => `${occurrence === 1 ? 'Annually on' : `Every ${occurrence} years on`} ${date}, ${times} times`,
      TH: (occurrence, date, times) => `${occurrence === 1 ? 'รายปีในเดือน' : `ทุก ${occurrence} ปี ในเดือน`} ${date}, ${times} ครั้ง`,
    },
  },
}
